import {useEffect, useMemo, useState} from 'react'
import {useNavigate, useLocation} from "react-router-dom";
import Login from "components/layouts/auth/Login.tsx";
import Signup from "components/layouts/auth/Signup.tsx";
import ChangePassword from "components/layouts/auth/ChangePassword.tsx";
import ForgotPassword from "components/layouts/auth/ForgotPassword.tsx";
import VerifyEmail from "components/layouts/auth/VerifyEmail.tsx";
import Modal from "components/atom/Modal.tsx";
import LangAndPolicies from "components/layouts/LangAndPolicies.tsx";
import {authActions} from "config/store/modules/auth.ts";
import {resetSessionId} from "config/ajax.ts";
import {STORAGE_WELCOME_MODAL_KEY} from "utils/data/global.ts";
import {useAppDispatch} from "config/store";


const MODES = {
    LOGIN: 'login',
    SIGNUP: 'signup',
    CHANGE_PWD: 'change-pwd',
    FORGOT_PWD: 'forgot-pwd',
    VERIFY_EMAIL: 'verify-email'
}

function AuthModals() {
    const [showModal, setShowModal] = useState<boolean>(false)
    const [mode, setMode] = useState(MODES.LOGIN)


    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const location = useLocation()

    const locationState = location.state || {}

    useEffect(() => {
        const modeInHash = location.hash.replace('#/auth/', '')
        const mode = Object.values(MODES).find(m => modeInHash.startsWith(m))

        if (mode) {
            setMode(mode)
            setShowModal(true)
        } else {
            setShowModal(false)
        }
    }, [location])




    const canClose = useMemo(() => {
        if (mode === MODES.VERIFY_EMAIL) {
            if (locationState.coming_from === 'user'){
                return true
            }
            return false
        }
        return true
    }, [locationState.coming_from, mode])

    const canGoBack = useMemo(() => {
        if (mode === MODES.VERIFY_EMAIL) {
            if (locationState.coming_from === 'user'){
                return false
            }
            return true
        }
        return false
    }, [locationState.coming_from, mode])

    const onClose = () => {
        if (!canClose) return
        setShowModal(false)
        setMode(MODES.LOGIN)


        navigate({pathname: location.pathname, hash: ''}, {replace: true})
    }

    const onGoBack = () => {
        if (mode === MODES.VERIFY_EMAIL) {

            dispatch(authActions.setJwt(null))
            dispatch(authActions.setUser(null))
            resetSessionId()
            window.localStorage.removeItem(STORAGE_WELCOME_MODAL_KEY)

            let hash = '#/auth/login'
            if (locationState.coming_from === 'signup') {
                hash = '#/auth/signup'
            }
            navigate({pathname: location.pathname, hash: hash}, {replace: true})
        }
    }

    if (!showModal) return null


    return (
        <div>

            <Modal noPadding
                   flexibleHeight
                   onClose={onClose}
                   canClose={canClose}
                   onGoBack={onGoBack}
                   canGoBack={canGoBack}>
                <div className="p-6">
                    {mode === MODES.LOGIN && (
                        <Login/>
                    )}
                    {mode === MODES.SIGNUP && (
                        <Signup/>
                    )}
                    {mode === MODES.CHANGE_PWD && (
                        <ChangePassword/>
                    )}
                    {mode === MODES.FORGOT_PWD && (
                        <ForgotPassword/>
                    )}
                    {mode === MODES.VERIFY_EMAIL && (
                        <VerifyEmail/>
                    )}
                </div>
                {mode !== MODES.VERIFY_EMAIL && (
                    <div className="w-full border-t border-gray-200">
                        <LangAndPolicies/>
                    </div>
                )}
            </Modal>
        </div>
    )

}

export default AuthModals
